<div class="">
  <div class="operational_kpis_title">Operational KPIs (24 Hours)</div>
  <div class="row align-items-center justify-between">
    <div class="operational_kpis_headers">
      <div class="">Number of Stops:</div>
      <div class="">Connectivity Drops:</div>
      <div class="">Run Time:</div>
      <div class="">Overload Runtime:</div>
      <div class="">Underload Runtime:</div>
      <div class="">Normal Load Runtime:</div>
    </div>
    <div
      *ngIf="!kpiLoader && !kpiDataErr"
      class="operational_kpis_headers"
      style="align-items: center"
    >
      <div class="">{{ kpiData.number_of_stops }}</div>
      <div class="">{{ kpiData.drop_count }}</div>
      <div class="">{{ kpiData.total_runtime }}Hrs</div>
      <div class="">
        {{ kpiData.over_load }}Hrs ({{ kpiData.over_load_per }})
      </div>
      <div class="">
        {{ kpiData.under_load }}Hrs ({{ kpiData.under_load_per }})
      </div>
      <div class="">{{ kpiData.normal_load }}Hrs ({{ kpiData.normal_load_per }}) </div>
    </div>

    <div *ngIf="kpiLoader" class="operational_kpis_headers">
      <div class="skeleton skeleton-text w_70"></div>
      <div class="skeleton skeleton-text w_70"></div>
      <div class="skeleton skeleton-text w_70"></div>
      <div class="skeleton skeleton-text w_70"></div>
      <div class="skeleton skeleton-text w_70"></div>
    </div>

    <div *ngIf="!kpiLoader && kpiDataErr" class="operational_kpis_headers">
      <div class="">N/A</div>
      <div class="">N/A</div>
      <div class="">N/A</div>
      <div class="">N/A</div>
      <div class="">N/A</div>
    </div>
  </div>
</div>
